import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";
import {
  CHIP_FONT_SIZE,
  CHIP_HEIGHT,
  CHIP_LETTER_SPACING,
  CHIP_PADDING,
  CHIP_RADIUS_CSS
} from "./approval-data-constants";

const ApprovalChip = withLiteObserverAndTheme<{
  label: string;
  toneColor: string;
  backgroundColor: string;
}>((props) => {
  const { label, toneColor, backgroundColor, theme } = props;
  const { unitX } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={CHIP_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={backgroundColor}
      style={{
        boxSizing: "border-box",
        width: "auto",
        flexShrink: 0,
        whiteSpace: "nowrap",
        border: `1px solid ${toneColor}`,
        borderRadius: CHIP_RADIUS_CSS,
        paddingLeft: CHIP_PADDING * unitX,
        paddingRight: CHIP_PADDING * unitX
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={CHIP_FONT_SIZE}
        text={label}
        isSpan={true}
        color={toneColor}
        style={{
          margin: 0,
          textTransform: "uppercase",
          letterSpacing: CHIP_LETTER_SPACING
        }}
      />
    </ET3Div>
  );
});
export default ApprovalChip;
